import { FormationService } from './../../services/formation/formation.service';
import { Component, OnInit, Input, HostBinding } from '@angular/core';
import { MDomain, MFormation } from '@argalis-apps/models';
import { CatalogConfigService } from '../../services/catalog-config/catalog-config.service';
import { CartConfigService } from '../../../cart/services/cart-config/cart-config.service';
import { ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'ags-fiche-formation-entete',
  templateUrl: './fiche-formation-entete.component.html',
  styleUrls: ['./fiche-formation-entete.component.scss']
})
export class FicheFormationEnteteComponent implements OnInit {
  @HostBinding('class') themeFlag: string;
  private _infoFormation: MFormation.IFormInfo;

  public modalite;
  @Input('modalite')
  set _modalite(value) {
    this.modalite = value;
  }

  @Input()
  get infoFormation(): MFormation.IFormInfo {
    return this._infoFormation;
  }
  set infoFormation(value: MFormation.IFormInfo) {
    this._infoFormation = value;
    if (value && value.domaine) {
      this.setupDomHierarchy(value.domaine);
    }
  }

  public domHierarchy: MDomain.IDomain[] = [];
  public cartLink = false;
  public id;
  public moda = '1';
  public title;
  public produit = [];
  public dom: MDomain.IDomain;
  public produitmodal;
  public docPresent;

  constructor(
    public catalogConfigService: CatalogConfigService,
    private cartConfigService: CartConfigService,
    private formationService: FormationService,
    private route: ActivatedRoute
  ) {
    this.themeFlag = `${this.themeFlag || ''} ${catalogConfigService.themingClassName}`;
  }

  ngOnInit() {
    this.downloadDoc();
    this.cartLink = !!(this.cartConfigService.getOptions() || ({} as any)).actif;
    this.formationService.changeEmitted$.subscribe(res => {
      if (res) {
        this.moda = res;
        this.downloadDoc();
      }
    });

    this.route.params.subscribe(
      (params: Params) => {
        this.id = params['identifier'];
      },
      error => {
        console.log(error);
      },
      () => {
        console.log('observable complete');
      }
    );
    this.formationService.getFormModaliteList(this.id).subscribe(
      res => {
        this.title = res[0].libelle;
      },
      err => {
        console.log(err);
      }
    );

    this.formationService.getDocument(this.id, this.produitmodal).subscribe(
      res => {
        this.docPresent = res;
      },
      error => {
        this.docPresent = void 0;
      }
    );
  }

  setupDomHierarchy(dom: any) {
    this.formationService.getDomain(this.id).subscribe(produit => {
      dom = {
        groupe: {
          id: produit.id_produit_groupe,
          libelle: (produit.libelle_produit_groupe || '').toString(),
          type: (produit.id_produit_groupe || '').toString()
        },
        secteur: {
          id: produit.id_produit_secteur,
          libelle: (produit.libelle_produit_secteur || '').toString(),
          type: (produit.id_produit_secteur || '').toString()
        },
        famille: {
          id: produit.id_produit_famille,
          libelle: (produit.libelle_produit_famille || '').toString(),
          type: (produit.id_produit_famille || '').toString()
        }
      };
      this.domHierarchy = Object.keys(dom).map(i => dom[i]);
    });
  }

  downloadDoc() {
    switch (Number(this.moda)) {
      case 1:
        this.produitmodal = 'id_produit_modalite_presentiel';
        break;
      case 2:
        this.produitmodal = 'id_produit_modalite_blended';
        break;
      case 3:
        this.produitmodal = 'id_produit_modalite_elearning';
        break;
    }
    this.route.params.subscribe(
      (params: Params) => {
        this.id = params['identifier'];
        this.formationService.getDocument(this.id, this.produitmodal).subscribe(res => {
          window.open(res.document);
        });
      },
      error => {
        console.log(error);
      },
      () => {
        console.log('observable complete');
      }
    );
  }
}
